export default __webpack_public_path__ + "static/media/livebyebay-white_turquoise.53db8632.svg";